import { UserActivityService } from '@/services/admin/UserActivityService'

export const namespaced = true

export const state = {
  activities: null,
  meta: null
}

export const mutations = {
  SET_ACTIVITIES(state, activities) {
    state.activities = activities.data
    state.meta = activities.meta
  }
}

export const actions = {
  getActivities({ commit }, userId) {
    return new Promise(resolve => {
      let userActivityService = new UserActivityService(userId, { limit: 10 })
      userActivityService.getActivities().then(response => {
        commit('SET_ACTIVITIES', response)
        resolve(response.data)
      })
    })
  }
}
